import React from "react";
import { ITooltip } from "../../../../shared/interfaces/ITooltip";
import "./Tooltip.scss";

const Tooltip = ({ children, className }: ITooltip) => {
  return <div className={`buff-tooltip ${className}`}>{children}</div>;
};

export default Tooltip;
